import {useState} from 'react';
import {NewContentIdeaForm} from './NewContentIdeaForm';
import {ContentIdeas} from './ContentIdeas';
import {Drawer} from 'antd';
import {useStore} from '@/store/root-store';
import styles from './style.module.scss';
import {observer} from 'mobx-react';

export const ContentIdeasDrawer = observer(() => {
  const {contentOptimizer: {currentPage, contentIdeas}} = useStore('');
  const [drawerVisible, setDrawerVisible] = useState(true);

  return (
    <>
      <Drawer
        visible={false}
        placement='right'
        width={'80vw'}
        onClose={() => {
          contentIdeas.clearContentIdeas();
          setDrawerVisible(false);
          currentPage.setIsOpenContentGeneratorDrawer(false);
        }}
        bodyStyle={{backgroundColor: '#F2F2F5', paddingLeft: '0', paddingRight: '0'}}
        className={styles.contentIdeasDrawer}
        afterVisibleChange={visible => {
          if (visible) setDrawerVisible(true);
        }}
      >
        <div className={styles.contentIdeasDrawerContent}>
          <div className={styles.contentIdeasTitle}>
            Content Helper
          </div>
          <NewContentIdeaForm drawerVisible={drawerVisible} store={contentIdeas} pageId={currentPage.content.uuid}/>
          <ContentIdeas store={contentIdeas}/>
        </div>
      </Drawer>
    </>
  );
});
